import { render, staticRenderFns } from "./MealSummaryDialog.vue?vue&type=template&id=d6109578&scoped=true&"
import script from "./MealSummaryDialog.vue?vue&type=script&lang=js&"
export * from "./MealSummaryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6109578",
  null
  
)

export default component.exports